/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  LOAD_REVIEWS,
  LOAD_REVIEWS_SUCCESS,
  LOAD_REVIEWS_ERROR,
  LoadReviewsActions,
  SWITCH_PAGE
} from './actions';
import Review from '../../server/domain/Review';
import { VotesDistribution } from '../../server/domain/ReviewSummary';

export interface ReviewAppState {
  averageRating?: number;
  allVotes?: number;
  distribution?: any[] | VotesDistribution[];
  errors?: any;
  isLoading?: boolean;
  isBundle?: boolean;
  limit: number;
  locale: string;
  page: number;
  productId: number;
  reviews?: Review[];
  reviewsMap?: Map<number, Review[]>;
  storeId: number;
  totalPages: number;
}

export default function reviewsReducer(state: ReviewAppState, action: LoadReviewsActions): ReviewAppState {
  switch (action.type) {
    case SWITCH_PAGE:
      return {
        ...state,
        page: action.payload.page
      };
    case LOAD_REVIEWS:
      return {
        ...state,
        isLoading: true
      };
    case LOAD_REVIEWS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reviews: action.payload.reviews,
        page: action.payload.currentPage,
        reviewsMap: new Map(state.reviewsMap).set(action.payload.currentPage, action.payload.reviews)
      };
    case LOAD_REVIEWS_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      };
    default:
      return state;
  }
}
